import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormTemplate, FormTemplateSection,
} from 'data/template/template.types';
import * as types from 'data/radiusParserOptions/radiusParserOptions.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import { FormLayout } from 'components/FormLayout';
import './radius-parser-options-form.scss';

type Props = {
  template: FormTemplate,
  data: Partial<types.RadiusParserOptions>
  i18nKeyPrefix?: string
  isEditing?: boolean,
  onFieldUpdate?: (param: FieldUpdateHandlerParam) => void
  onFieldCreateNew?: any
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.RadiusParserOptions
}

export const RADIUS_PARSER_OPTIONS_I18N_KEY = 'radiusParserOptions.form';

export const RadiusParserOptionsForm = forwardRef<Ref, Props>(({
  template,
  data,
  isEditing,
  i18nKeyPrefix = RADIUS_PARSER_OPTIONS_I18N_KEY,
  onFieldUpdate = () => null,
  onFieldCreateNew,
}: Props, ref) => {
  const { t } = useTranslation();
  const mainRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainFormValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;

    return isMainFormValid;
  };

  const getValues = () => {

    return mainRef.current?.getValues();
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param);

  return (
    <div className="redius-parser-options-form" data-testid="RadiusParserOptionsForm">
      <div data-testid="RadiusParserOptionsFormMain">
        <FormLayout>
          <Form
            ref={mainRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template.main as FormTemplateSection).fields}
            layout={(template.main as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
            fieldCreateNewHandler={onFieldCreateNew}
          />
        </FormLayout>
      </div>
    </div>
  );
});

export default RadiusParserOptionsForm;
